import React from 'react';
import Grid from '../../common/Grid/Grid';
import IDPCardItem from './IDPCardItem';

const IDPGrid = ({
  goals,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  onView,
  onEdit,
  currentEmployeeId,
}) => {
  // Custom renderer for IDP items
  const renderIDPItem = ({ item, onClick }) => {
    const isOwnGoal = item.employee?.id != null && item.employee?.id === currentEmployeeId;
    return <IDPCardItem goal={item} onClick={() => onClick(item)} onView={onView} onEdit={onEdit} isOwnGoal={isOwnGoal} />;
  };

  return (
    <Grid
      items={goals}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderIDPItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      emptyStateTitle="No Development Plans Found"
      emptyStateDescription="No development plans found matching the current search criteria. Create your first development plan by clicking the 'New Development Plan' button."
      endOfListMessage="You've reached the end of the list"
      rowHeight={300}
    />
  );
};

export default IDPGrid;
